export const MODAL_TITLE = 'Self-Tour Reshedule Confirmation';
export const MODAL_DESCRIPTION_QUESTION = 'Are you sure you want to reschedule the self-tour?';
export const MODAL_DESCRIPTION = 'This action will modify your appointment time.';
export const MODAL_WARNING_MSG = 'If you cancel the tour more than 3 times, an admin fee of $25 will be charged';
export const CANCEL_RESCHEDULE_TOUR = `No, don't reshedule`;
export const RESCHEDULE_TOUR = 'Yes, reshedule the tour';